import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import BottomNav from './BottomNav';

const MAIN_NAV_PATH_PREFIXES = [
  '/chats',
  '/lounge',
  '/invite-confirm',
  '/call',
  '/post-call',
  '/match',
  '/wallet',
  '/earnings',
  '/profile',
  '/settings',
  '/privacy',
  '/terms',
];

export function ScreenShell({ children, titleBar, showMainNav, contentClassName, contentStyle }) {
  const location = useLocation();
  const shouldShowMainNav = showMainNav ?? MAIN_NAV_PATH_PREFIXES.some((prefix) => location.pathname.startsWith(prefix));

  return (
    <div className="figma-root">
      <div className="figma-phone">
        {titleBar ? <div className="figma-topbar">{titleBar}</div> : null}
        <div className={`figma-content ${contentClassName || ''}`.trim()} style={contentStyle}>
          {children}
          {shouldShowMainNav ? <PaymentFooter /> : null}
        </div>
        {shouldShowMainNav ? <BottomNav /> : null}
      </div>
    </div>
  );
}

export function PaymentFooter() {
  return (
    <footer className="ic-app-footer">
      <div className="ic-app-footer-top">
        <div className="ic-app-footer-security">
          <ShieldCheck size={12} aria-hidden="true" />
          <span>Encrypted payments</span>
        </div>
        <div className="ic-payment-brands" aria-label="Payment card brands">
          <span className="ic-payment-brand ic-payment-brand-visa" aria-label="Visa">VISA</span>
          <span className="ic-payment-brand-mastercard" aria-label="Mastercard">
            <span />
            <span />
          </span>
          <span className="ic-payment-brand ic-payment-brand-amex" aria-label="American Express">AMEX</span>
          <span className="ic-payment-brand ic-payment-brand-discover" aria-label="Discover">DISCOVER</span>
        </div>
      </div>
      <div className="ic-app-footer-bottom">
        <p>© 2026 Instant Connections</p>
        <nav aria-label="Legal">
          <Link to="/terms">Terms</Link>
          <Link to="/privacy">Privacy</Link>
        </nav>
      </div>
    </footer>
  );
}

export function PrimaryButton({ children, to, onClick, disabled }) {
  if (to) {
    return (
      <Link
        to={to}
        className={`figma-btn figma-btn-primary ${disabled ? 'is-disabled' : ''}`}
        onClick={disabled ? (e) => e.preventDefault() : undefined}
      >
        {children}
      </Link>
    );
  }

  return (
    <button className="figma-btn figma-btn-primary" onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
}

export function SecondaryButton({ children, to, onClick }) {
  if (to) {
    return (
      <Link to={to} className="figma-btn figma-btn-secondary">
        {children}
      </Link>
    );
  }

  return (
    <button type="button" className="figma-btn figma-btn-secondary" onClick={onClick}>
      {children}
    </button>
  );
}
